__turbopack_context__.v({
  "newsTeaserDiv": "BoardSectionItemHeroNewsteaser-module-scss-module__BrFKFa__newsTeaserDiv",
  "newsTeaserHeadline": "BoardSectionItemHeroNewsteaser-module-scss-module__BrFKFa__newsTeaserHeadline",
  "newsTeaserItem": "BoardSectionItemHeroNewsteaser-module-scss-module__BrFKFa__newsTeaserItem",
  "newsTeaserItemImage": "BoardSectionItemHeroNewsteaser-module-scss-module__BrFKFa__newsTeaserItemImage",
  "newsTeaserItemText": "BoardSectionItemHeroNewsteaser-module-scss-module__BrFKFa__newsTeaserItemText",
  "showDesktopTitle": "BoardSectionItemHeroNewsteaser-module-scss-module__BrFKFa__showDesktopTitle",
  "showMobileTitle": "BoardSectionItemHeroNewsteaser-module-scss-module__BrFKFa__showMobileTitle",
});
